export default "__VITE_ASSET__2f566ceb__"